import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useAuth } from "@src/context";

/**
 * ProfileCompletionOverlay component that blurs the page content
 * and shows a prompt to complete the profile
 */
const ProfileCompletionOverlay = ({ children }) => {
  const { LoginData } = useAuth();
  const userRole = LoginData?.role;
  
  // Get the profile creation path based on role
  const profilePath = userRole === "candidate" 
    ? "/candidate-profile" 
    : "/employer-profile";
  
  const roleDisplay = userRole === "candidate" ? "Candidate" : "Employer";
  
  return (
    <div className="position-relative">
      {/* Blurred content */}
      <div className="filter-blur" style={{ pointerEvents: "none" }}>
        {children}
      </div>
      
      {/* Overlay with profile completion prompt */}
      <div 
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center profile-completion-overlay"
        style={{ 
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          zIndex: 1050
        }}
      >
        <div className="profile-completion-card">
          <h2 className="mb-3">Complete Your Profile</h2>
          <p className="mb-4">
            Please complete your {roleDisplay} profile to access all features of the platform.
          </p>
          <Button 
            as={Link} 
            to={profilePath} 
            variant="primary" 
            size="lg"
            className="profile-completion-btn"
          >
            Complete Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionOverlay;
